import React, { Component } from 'react';
import {
  Grid,
  TextField,
  MenuItem,
  CircularProgress,
  Box,
} from '@mui/material';
import {
  DatePicker,
  TimePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';
import InfoTitle from '../../components/InfoTitle';
import Button from '../../../../../../components/Button';
import { Styles } from './styles';
import { firstLetterCapitalize } from '../../../../../../utils/text-helper';
import { luftPost } from '../../../../../../shared/http';
import { showToastError } from '../../../../../../components/toasty';

export default class TrackingDetailsOccurrenceForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      type: null,
      observation: '',
      date: null,
      hour: null,
      additionalFields: {},
      errors: {},
    };

    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(field) {
    return eventOrValue => {
      const value =
        eventOrValue && eventOrValue.target
          ? eventOrValue.target.value
          : eventOrValue;
      this.setState({ [field]: value });
    };
  }

  handleAdditionalFieldChange(field) {
    return eventOrValue => {
      const value =
        eventOrValue && eventOrValue.target
          ? eventOrValue.target.value
          : eventOrValue;

      this.setState(prev => ({
        additionalFields: {
          ...prev.additionalFields,
          [field]: value,
        },
      }));
    };
  }

  handleTypeChange(event) {
    const { value } = event.target;
    const { typeList } = this.props;
    const typeData = typeList?.data || [];
    const selectedType = typeData.find(item => item.id === value) || null;

    const addFields = {};
    for (let i of selectedType.additionalFields || []) {
      addFields[i] = null;
    }

    this.setState({
      type: selectedType,
      additionalFields: addFields,
    });
  }

  isValidDate(date) {
    return date instanceof Date && !isNaN(date);
  }

  isValidTime(time) {
    return time instanceof Date && !isNaN(time);
  }

  validateForm() {
    const { type, observation, date, hour, additionalFields } = this.state;
    const errors = {};

    if (!type) errors.type = 'Campo obrigatório';
    if (!observation.trim()) errors.observation = 'Campo obrigatório';
    if (!this.isValidDate(date)) errors.date = 'Data inválida';
    if (!this.isValidTime(hour)) errors.hour = 'Horário inválido';

    if (type && type.additionalFields) {
      for (const key of type.additionalFields) {
        const value = additionalFields[key];
        if (!value) {
          errors[key] = 'Campo obrigatório';
        }
      }
    }

    this.setState({ errors });
    return errors;
  }

  async handleSubmit(e) {
    try {
      e.preventDefault();

      this.setState({ isSubmitting: true });
      const errors = this.validateForm();
      const { nfData } = this.props;
      const { type, observation, date, hour, additionalFields } = this.state;

      const hasErrors = Object.values(errors).some(Boolean);
      if (hasErrors) return;

      const combinedDateTime = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        hour.getHours(),
        hour.getMinutes(),
      );

      const payload = {
        invoiceId: nfData.id,
        code: type.code,
        type: type.type,
        occurrenceText: observation,
        occurrenceDate: combinedDateTime,
        updateStatus: type.updateStatus,
        isTrip: type.isTrip,
        isJustified: type.isJustified,
        isVisible: type.isVisible,
        isManual: type.isManual,
        ...additionalFields,
      };

      const response = await luftPost('/Invoice/CreateOccurrence', payload);
      if (response.success) {
        this.props.onSuccess();
      }
    } catch (error) {
      const responseBody = error.responseBody;
      const fieldErrors = {};
      const unmappedMessages = [];
      const validFormFields = [
        'type',
        'observation',
        'date',
        'hour',
        'scheduledDate',
      ];

      if (
        responseBody &&
        responseBody.notifications &&
        Array.isArray(responseBody.notifications)
      ) {
        responseBody.notifications.forEach(notification => {
          if (notification.key && notification.value) {
            const fieldKey =
              notification.key.charAt(0).toLowerCase() +
              notification.key.slice(1);

            const isValidField =
              validFormFields.includes(fieldKey) ||
              (this.state.type?.additionalFields || []).includes(fieldKey);

            if (isValidField) {
              fieldErrors[fieldKey] = notification.value;
            } else {
              unmappedMessages.push(notification.value);
            }
          }
        });

        if (Object.keys(fieldErrors).length > 0) {
          this.setState(prevState => ({
            errors: {
              ...prevState.errors,
              ...fieldErrors,
            },
          }));
        }
      }

      if (unmappedMessages.length > 0) {
        showToastError(unmappedMessages.join(' '));
      } else if (
        !responseBody?.notifications ||
        !Array.isArray(responseBody.notifications) ||
        responseBody.notifications.length === 0
      ) {
        const errorMessage =
          responseBody?.message ||
          error.message ||
          'Não foi possível completar a ação';
        showToastError(errorMessage);
      }
    } finally {
      this.setState({ isSubmitting: false });
    }
  }

  renderScheduleDate() {
    const selectedType = this.state.type;

    if (
      !selectedType ||
      !selectedType.additionalFields ||
      !Array.isArray(selectedType.additionalFields) ||
      !selectedType.additionalFields.includes('scheduledDate')
    ) {
      return null;
    }

    return (
      <Grid item xs={6}>
        <DatePicker
          label="Data agendada"
          value={this.state.additionalFields['scheduledDate'] || null}
          onChange={this.handleAdditionalFieldChange('scheduledDate')}
          inputFormat="dd/MM/yyyy"
          renderInput={params => (
            <TextField
              {...params}
              fullWidth={true}
              variant={'outlined'}
              size={'small'}
              error={!!this.state.errors['scheduledDate']}
              helperText={this.state.errors['scheduledDate']}
              InputProps={{
                ...params.InputProps,
                endAdornment: null,
              }}
            />
          )}
        />
      </Grid>
    );
  }

  // pedro.lima@wefit.com.br: Vai entrar na V1.2 desse fluxo, só descomentar e validar a implementação
  // renderFileUpload = () => {
  //   const selectedType = this.state.type;

  //   if (!selectedType ||
  //       !selectedType.additionalFields ||
  //       !Array.isArray(selectedType.additionalFields) ||
  //       !selectedType.additionalFields.includes('file')) {
  //     return null;
  //   }

  //   return <Grid item xs={12}>
  //     <FileUpload error={this.state.errors['file']} onChange={this.handleAdditionalFieldChange('file')} />
  //   </Grid>;
  // }

  render() {
    const { toggleForm, typeList } = this.props;
    const { type, observation, date, hour, errors, isSubmitting } = this.state;

    const isLoading = typeList?.isFetching || isSubmitting;
    const typeData = typeList?.data || [];

    return (
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <Styles.FormContainer onSubmit={this.handleSubmit}>
          <InfoTitle>Nova ocorrência</InfoTitle>

          <Grid container spacing={2} marginTop={0.5}>
            <Grid item xs={6}>
              <TextField
                select
                fullWidth
                label="Tipo da ocorrência"
                value={type?.id ?? ''}
                onChange={this.handleTypeChange}
                variant="outlined"
                size="small"
                error={!!errors.type}
                helperText={errors.type}
                disabled={isLoading}
              >
                {isLoading ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    p={1}
                  >
                    <CircularProgress size={24} />
                  </Box>
                ) : typeData.length > 0 ? (
                  typeData.map(item => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.code} - {firstLetterCapitalize(item.type)}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>Nenhum tipo disponível</MenuItem>
                )}
              </TextField>
            </Grid>

            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Observação"
                placeholder="Descreva aqui..."
                value={observation}
                onChange={this.handleChange('observation')}
                variant="outlined"
                size="small"
                error={!!errors.observation}
                helperText={errors.observation}
              />
            </Grid>

            <Grid item xs={6} md={3}>
              <DatePicker
                label="Data ocorrência"
                value={date}
                onChange={this.handleChange('date')}
                inputFormat="dd/MM/yyyy"
                renderInput={params => (
                  <TextField
                    {...params}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.date}
                    helperText={errors.date}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: null,
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={6} md={3}>
              <TimePicker
                label="Horário ocorrência"
                ampm={false}
                value={hour}
                onChange={this.handleChange('hour')}
                renderInput={params => (
                  <TextField
                    {...params}
                    fullWidth
                    variant="outlined"
                    size="small"
                    error={!!errors.hour}
                    helperText={errors.hour}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: null,
                    }}
                  />
                )}
              />
            </Grid>

            {this.renderScheduleDate()}
            {/* {this.renderFileUpload()} */}

            <Grid item xs={12}>
              <Styles.ButtonRow>
                <Styles.CancelButton
                  type="button"
                  text="Cancelar"
                  skin="white"
                  onClick={toggleForm}
                />
                <Button
                  type="submit"
                  text={isLoading ? 'Salvando...' : 'Salvar'}
                  skin="primary"
                  disabled={isLoading}
                />
              </Styles.ButtonRow>
            </Grid>
          </Grid>
        </Styles.FormContainer>
      </LocalizationProvider>
    );
  }
}
